<template>
	<div class="model1">
		<div>
			<div class="article_l_title">
				<!-- <img class="img1" src="../../assets/main/title_icon.jpg" alt="">
                <span>搜索</span> -->
			</div>
			<el-form
				:model="forms"
				ref="ruleForm"
				label-width="124px"
				class="demo-ruleForm"
			>
				<el-form-item
					label="关键字："
					prop="name"
					style="margin-top:20px;"
				>
					<el-input
						size="medium"
						style="width:515px;border: 1px solid #F3F3F3;"
						placeholder="请输入产品名称、产品编码"
						v-model="forms.input1"
					></el-input>
					<span @click="searchKeyword" class="btn_search">查询</span>
					<span @click="clearKeyword" class="btn_clear">清空</span>
				</el-form-item>
				<div style="width:100%;">
					<el-form-item
						label="信托功能："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion1"
							class="normalbtn clearRegion1"
							>不限</span
						>
						<el-select
							@change="changeRegion1"
							v-model="forms.region1"
							placeholder="请选择信托功能"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="投资类"
								value="投资类"
							></el-option>
							<el-option
								label="融资类"
								value="融资类"
							></el-option>
							<el-option
								label="事务管理"
								value="事务管理"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="发行机构："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion2"
							class="normalbtn clearRegion2"
							>不限</span
						>
						<el-select
							@change="changeRegion2"
							v-model="forms.region2"
							placeholder="请选择发行机构"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="安徽国元信托有限责任公司"
								value="安徽国元信托有限责任公司"
							></el-option>
							<el-option
								label="安信信托股份有限公司"
								value="安信信托股份有限公司"
							></el-option>
							<el-option
								label="安徽国元信托有限责任公司"
								value="安徽国元信托有限责任公司"
							></el-option>
							<el-option
								label="百瑞信托有限责任公司"
								value="百瑞信托有限责任公司"
							></el-option>
							<el-option
								label="北京国际信托有限公司"
								value="北京国际信托有限公司"
							></el-option>
							<el-option
								label="渤海国际信托股份有限公司"
								value="渤海国际信托股份有限公司"
							></el-option>
							<el-option
								label="长安国际信托股份有限公司"
								value="长安国际信托股份有限公司"
							></el-option>
							<el-option
								label="大业信托有限责任公司"
								value="大业信托有限责任公司"
							></el-option>
							<el-option
								label="东莞信托有限公司"
								value="东莞信托有限公司"
							></el-option>
							<el-option
								label="光大兴陇信托有限责任公司"
								value="光大兴陇信托有限责任公司"
							></el-option>
							<el-option
								label="广东粤财信托有限公司"
								value="广东粤财信托有限公司"
							></el-option>
							<el-option
								label="国联信托股份有限公司"
								value="国联信托股份有限公司"
							></el-option>
							<el-option
								label="国民信托有限公司"
								value="国民信托有限公司"
							></el-option>
							<el-option
								label="国通信托有限责任公司"
								value="国通信托有限责任公司"
							></el-option>
							<el-option
								label="国投泰康信托有限公司"
								value="国投泰康信托有限公司"
							></el-option>
							<el-option
								label="杭州工商信托股份有限公司"
								value="杭州工商信托股份有限公司"
							></el-option>
							<el-option
								label="湖南省信托有限责任公司"
								value="湖南省信托有限责任公司"
							></el-option>
							<el-option
								label="华澳国际信托有限公司"
								value="华澳国际信托有限公司"
							></el-option>
							<el-option
								label="华宝信托有限责任公司"
								value="华宝信托有限责任公司"
							></el-option>
							<el-option
								label="华能贵诚信托有限公司"
								value="华能贵诚信托有限公司"
							></el-option>
							<el-option
								label="华润深国投信托有限公司"
								value="华润深国投信托有限公司"
							></el-option>
							<el-option
								label="华鑫国际信托有限公司"
								value="华鑫国际信托有限公司"
							></el-option>
							<el-option
								label="建信信托有限责任公司"
								value="建信信托有限责任公司"
							></el-option>
							<el-option
								label="江苏省国际信托有限责任公司"
								value="江苏省国际信托有限责任公司"
							></el-option>
							<el-option
								label="交银国际信托有限公司"
								value="交银国际信托有限公司"
							></el-option>
							<el-option
								label="昆仑信托有限责任公司"
								value="昆仑信托有限责任公司"
							></el-option>
							<el-option
								label="陆家嘴国际信托有限公司"
								value="陆家嘴国际信托有限公司"
							></el-option>
							<el-option
								label="平安信托有限责任公司"
								value="平安信托有限责任公司"
							></el-option>
							<el-option
								label="山东省国际信托股份有限公司"
								value="山东省国际信托股份有限公司"
							></el-option>
							<el-option
								label="山西信托股份有限公司"
								value="山西信托股份有限公司"
							></el-option>
							<el-option
								label="陕西省国际信托股份有限公司"
								value="陕西省国际信托股份有限公司"
							></el-option>
							<el-option
								label="上海爱建信托有限责任公司"
								value="上海爱建信托有限责任公司"
							></el-option>
							<el-option
								label="上海国际信托有限公司"
								value="上海国际信托有限公司"
							></el-option>
							<el-option
								label="四川信托有限公司"
								value="四川信托有限公司"
							></el-option>
							<el-option
								label="苏州信托有限公司"
								value="苏州信托有限公司"
							></el-option>
							<el-option
								label="万向信托股份公司"
								value="万向信托股份公司"
							></el-option>
							<el-option
								label="万向信托有限公司"
								value="万向信托有限公司"
							></el-option>
							<el-option
								label="五矿国际信托有限公司"
								value="五矿国际信托有限公司"
							></el-option>
							<el-option
								label="西部信托有限公司"
								value="西部信托有限公司"
							></el-option>
							<el-option
								label="西藏信托有限公司"
								value="西藏信托有限公司"
							></el-option>
							<el-option
								label="厦门国际信托有限公司"
								value="厦门国际信托有限公司"
							></el-option>
							<el-option
								label="兴业国际信托有限公司"
								value="兴业国际信托有限公司"
							></el-option>
							<el-option
								label="英大国际信托有限责任公司"
								value="英大国际信托有限责任公司"
							></el-option>
							<el-option
								label="云南国际信托有限公司"
								value="云南国际信托有限公司"
							></el-option>
							<el-option
								label="浙商金汇信托股份有限公司"
								value="浙商金汇信托股份有限公司"
							></el-option>
							<el-option
								label="中国对外经济贸易信托有限公司"
								value="中国对外经济贸易信托有限公司"
							></el-option>
							<el-option
								label="中国金谷国际信托有限责任公司"
								value="中国金谷国际信托有限责任公司"
							></el-option>
							<el-option
								label="中国民生信托有限公司"
								value="中国民生信托有限公司"
							></el-option>
							<el-option
								label="中海信托股份有限公司"
								value="中海信托股份有限公司"
							></el-option>
							<el-option
								label="中航信托股份有限公司"
								value="中航信托股份有限公司"
							></el-option>
							<el-option
								label="中建投信托股份有限公司"
								value="中建投信托股份有限公司"
							></el-option>
							<el-option
								label="中建投信托有限责任公司"
								value="中建投信托有限责任公司"
							></el-option>
							<el-option
								label="中江国际信托股份有限公司"
								value="中江国际信托股份有限公司"
							></el-option>
							<el-option
								label="中粮信托有限责任公司"
								value="中粮信托有限责任公司"
							></el-option>
							<el-option
								label="中融国际信托有限公司"
								value="中融国际信托有限公司"
							></el-option>
							<el-option
								label="中铁信托有限责任公司"
								value="中铁信托有限责任公司"
							></el-option>
							<el-option
								label="中信信托有限责任公司"
								value="中信信托有限责任公司"
							></el-option>
							<el-option
								label="中原信托有限公司"
								value="中原信托有限公司"
							></el-option>
							<el-option
								label="重庆国际信托股份有限公司"
								value="重庆国际信托股份有限公司"
							></el-option>
							<el-option
								label="紫金信托有限责任公司"
								value="紫金信托有限责任公司"
							></el-option>
							<el-option
								label="甘肃信托有限责任公司"
								value="甘肃信托有限责任公司"
							></el-option>
							<el-option
								label="吉林泛亚信托投资有限责任公司"
								value="吉林泛亚信托投资有限责任公司"
							></el-option>
							<el-option
								label="长城新盛信托有限责任公司"
								value="长城新盛信托有限责任公司"
							></el-option>
							<el-option
								label="新时代信托股份有限公司"
								value="新时代信托股份有限公司"
							></el-option>
							<el-option
								label="中诚信托有限责任公司"
								value="中诚信托有限责任公司"
							></el-option>
							<el-option
								label="北方国际信托股份有限公司"
								value="北方国际信托股份有限公司"
							></el-option>
							<el-option
								label="华信信托股份有限公司"
								value="华信信托股份有限公司"
							></el-option>
							<el-option
								label="吉林省信托有限责任公司"
								value="吉林省信托有限责任公司"
							></el-option>
							<el-option
								label="广州国际信托投资公司"
								value="广州国际信托投资公司"
							></el-option>
							<el-option
								label="天津信托有限责任公司"
								value="天津信托有限责任公司"
							></el-option>
							<el-option
								label="华宸信托有限责任公司"
								value="华宸信托有限责任公司"
							></el-option>
							<el-option
								label="雪松国际信托股份有限公司"
								value="雪松国际信托股份有限公司"
							></el-option>
							<el-option
								label="金新信托投资股份有限公司"
								value="金新信托投资股份有限公司"
							></el-option>
							<el-option
								label="中泰信托有限责任公司"
								value="中泰信托有限责任公司"
							></el-option>
							<el-option
								label="新华信托股份有限公司"
								value="新华信托股份有限公司"
							></el-option>
							<el-option
								label="华融国际信托有限责任公司"
								value="华融国际信托有限责任公司"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="主要投向行业："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion3"
							class="normalbtn clearRegion3"
							>不限</span
						>
						<el-select
							@change="changeRegion3"
							v-model="forms.region3"
							placeholder="请选择主要投向行业"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="农林牧渔业"
								value="农林牧渔业"
							></el-option>
							<el-option
								label="采矿业"
								value="采矿业"
							></el-option>
							<el-option
								label="电力、热力、燃气及水生产和供应业"
								value="电力、热力、燃气及水生产和供应业"
							></el-option>
							<el-option
								label="房地产业"
								value="房地产业"
							></el-option>
							<el-option
								label="公共管理、社会保障和社会组织"
								value="公共管理、社会保障和社会组织"
							></el-option>
							<el-option
								label="建筑业,金融业,科学研究和技术服务业"
								value="建筑业,金融业,科学研究和技术服务业"
							></el-option>
							<el-option
								label="建筑业,水利、环境和公共设施管理业,其他"
								value="建筑业,水利、环境和公共设施管理业,其他"
							></el-option>
							<el-option
								label="交通运输、仓储和邮政业"
								value="交通运输、仓储和邮政业"
							></el-option>
							<el-option label="教育" value="教育"></el-option>
							<el-option
								label="金融业"
								value="金融业"
							></el-option>
							<el-option
								label="科学研究和技术服务业"
								value="科学研究和技术服务业"
							></el-option>
							<el-option
								label="批发和零售业"
								value="批发和零售业"
							></el-option>
							<el-option label="其他" value="其他"></el-option>
							<el-option
								label="水利、环境和公共设施管理业"
								value="水利、环境和公共设施管理业"
							></el-option>
							<el-option
								label="水利、环境和公共设施管理业,教育,文化他"
								value="水利、环境和公共设施管理业,教育,文化他"
							></el-option>
							<el-option
								label="水利、环境和公共设施管理业,其他"
								value="水利、环境和公共设施管理业,其他"
							></el-option>
							<el-option
								label="信息传输、软件和信息技术服务业"
								value="信息传输、软件和信息技术服务业"
							></el-option>
							<el-option
								label="制造业"
								value="制造业"
							></el-option>
							<el-option
								label="租赁和商务服务业"
								value="租赁和商务服务业"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="财产运用方式："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion6"
							class="normalbtn clearRegion6"
							>不限</span
						>
						<el-select
							@change="changeRegion6"
							v-model="forms.region4"
							placeholder="请选择财产运用方式"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="信托贷款"
								value="信托贷款"
							></el-option>
							<el-option
								label="资产及其收（受）益权"
								value="资产及其收（受）益权"
							></el-option>
							<el-option
								label="长期股权投资"
								value="长期股权投资"
							></el-option>
							<el-option
								label="持有并管理"
								value="持有并管理"
							></el-option>
							<el-option
								label="股票投资"
								value="股票投资"
							></el-option>
							<el-option
								label="其他债权资产"
								value="其他债权资产"
							></el-option>
							<el-option
								label="实物及其他资产"
								value="实物及其他资产"
							></el-option>
							<el-option
								label="特定资产及其收（受）"
								value="特定资产及其收（受）"
							></el-option>
							<el-option
								label="信托贷款"
								value="信托贷款"
							></el-option>
							<el-option
								label="信托贷款,长期股权投资"
								value="信托贷款,长期股权投资"
							></el-option>
							<el-option
								label="债券投资"
								value="债券投资"
							></el-option>
							<el-option
								label="资产及其收（受）益权（不附回购）"
								value="资产及其收（受）益权（不附回购）"
							></el-option>
							<el-option
								label="资产及其收（受）益权（附回购）"
								value="资产及其收（受）益权（附回购）"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="首次申请日期："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion4"
							class="normalbtn clearRegion4"
							>不限</span
						>
						<el-date-picker
							@change="changeDateFn"
							style="width:229px;border: 1px solid #F3F3F3;"
							size="large"
							v-model="dateRaneg"
							unlink-panels
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item
						label="公示日期："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion5"
							class="normalbtn clearRegion5"
							>不限</span
						>
						<el-date-picker
							@change="changeDateFn2"
							style="width:229px;border: 1px solid #F3F3F3;"
							size="large"
							v-model="dateRaneg2"
							unlink-panels
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="m1_top_box">
			<h5>
				<img
					src="../../assets/main/title_icon.jpg"
					alt=""
				/>按主要投向行业统计产品数量 （截至{{ titleAnd1 }}）
			</h5>
			<h5>
				<img
					src="../../assets/main/title_icon.jpg"
					alt=""
				/>按产品登记年份统计产品数量 （截至{{ titleAnd2 }}）
			</h5>
			<div class="m1_echarts_box">
				<div class="m1_echarts1" id="m1_echarts1"></div>
				<div class="m1_echarts2" id="m1_echarts2"></div>
			</div>
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<!-- <el-date-picker
                    @change="changeDateFn"
                    style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
                    size="large"
                    v-model="dateRaneg"
                    unlink-panels
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <div class="m1_download_data">导出数据</div> -->
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					:row-key="(row) => row.Code"
					:expand-row-keys="expandRowKeys"
					@row-click="rowClickFn"
					border
				>
					<el-table-column type="expand">
						<template slot-scope="props">
							<table class="mailTable">
								<tr>
									<td class="column">首次申请登记日期：</td>
									<td>
										{{ props.row.RegisterDate | subData3 }}
									</td>
								</tr>
								<tr>
									<td class="column">存续期限（月）：</td>
									<td>{{ props.row.RenewalPeriod }}</td>
								</tr>
								<tr>
									<td class="column">信托功能：</td>
									<td>{{ props.row.TrustFunction }}</td>
								</tr>
								<tr>
									<td class="column">主要投向行业：</td>
									<td>{{ props.row.MainSector }}</td>
								</tr>
								<tr>
									<td class="column">财产运用方式：</td>
									<td>{{ props.row.UseMode }}</td>
								</tr>
							</table>
						</template>
					</el-table-column>
					<el-table-column label="产品名称" prop="Name">
					</el-table-column>
					<el-table-column label="产品编码" prop="Code">
					</el-table-column>
					<el-table-column label="发行机构" prop="ReleaseInstitute">
					</el-table-column>
					<el-table-column
						label="地区"
						width="80px"
						prop="InstitueRegion"
					>
					</el-table-column>
					<el-table-column
						label="公示日期"
						width="100px"
						prop="PubDate"
					>
					</el-table-column>
				</el-table>
				<!-- <el-empty v-if="dataList.length <= 0" description="暂无数据!"></el-empty> -->
			</ul>
			<div style="font-size: 14px;float: right;">
				数据来源：中国信托登记有限责任公司
			</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 绿色公募基金
	props: ['currentChoose'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			dateRaneg2: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			startDate2: '', //日历开始时间
			endDate2: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
			forms: {
				input1: '', //关键字查询
				region1: '', //基金类型
				region2: '',
				region3: '',
				region4: '',
				region5: '',
			},
			expandRowKeys: [], //默认展开的行id
			titleAnd1: '',
			titleAnd2: '',
			titleAnd3: '',
			titleAnd4: '',
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.echartsfn1();
			this.echartsfn3();
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();
			}
			//console.log(val,'test');
		},
		//时间段清零函数
		dateRaneg2(val) {
			if (val == null) {
				this.startDate2 = '';
				this.endDate2 = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();
			}
			//console.log(val,'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);

		this.echartsfn1();
		this.echartsfn3();
	},
	methods: {
		//table行的点击事件
		rowClickFn(row, column, event) {
			//console.log(row,'row')
			if (this.expandRowKeys.includes(row.Code)) {
				this.expandRowKeys = this.expandRowKeys.filter(
					(val) => val !== row.Code
				);
			} else {
				this.expandRowKeys.push(row.Code);
			}
			//console.log(this.expandRowKeys,'test table');
		},
		//债券类型切换
		changeRegion1(val) {
			this.currentPage = 1;
			$('.clearRegion1').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券类型清除
		clearRegion1() {
			this.currentPage = 1;
			$('.clearRegion1').removeClass('active');
			this.forms.region1 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券期限切换
		changeRegion2(val) {
			this.currentPage = 1;
			$('.clearRegion2').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券期限清除
		clearRegion2() {
			this.currentPage = 1;
			$('.clearRegion2').removeClass('active');
			this.forms.region2 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份切换
		changeRegion3(val) {
			this.currentPage = 1;
			$('.clearRegion3').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份清除
		clearRegion3() {
			this.currentPage = 1;
			$('.clearRegion3').removeClass('active');
			this.forms.region3 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份切换
		changeRegion6(val) {
			this.currentPage = 1;
			$('.clearRegion6').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份清除
		clearRegion6() {
			this.currentPage = 1;
			$('.clearRegion6').removeClass('active');
			this.forms.region4 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//时间清除
		clearRegion4() {
			this.currentPage = 1;
			$('.clearRegion4').removeClass('active');
			this.startDate = '';
			this.endDate = '';
			this.dateRaneg = [];
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//时间清除
		clearRegion5() {
			this.currentPage = 1;
			$('.clearRegion5').removeClass('active');
			this.startDate2 = '';
			this.endDate2 = '';
			this.dateRaneg2 = [];
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//点击关键字查询
		searchKeyword() {
			this.currentPage = 1;
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//点击关键字清除
		clearKeyword() {
			this.currentPage = 1;
			this.forms.input1 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//table的单元格样式
		cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0) {
				return 'background:#fff;';
			} else {
				return 'background:#F5F7F5;';
			}
			// if (row.rowIndex == 0) {
			//     return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;";
			// }
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 饼图1
		echartsfn1() {
			var chartDom = document.getElementById('m1_echarts1');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				// title: {
				//     text: 'Referer of a Website',
				//     subtext: 'Fake Data',
				//     left: 'center'
				// },
				color: ['#ebdecb', '#8aa87d', '#7d97a8'],
				grid: {
					left: '1%',
					right: '1%',
					bottom: '4%',
					top: '3%',
					containLabel: true,
				},
				// tooltip: {
				//     trigger: 'item'
				// },
				tooltip: {
					trigger: 'item',
					formatter:
						'按主要投向行业统计产品数量 <br/>{b} : {c}只 ({d}%)',
					position: ['20%', '80%'],
				},
				// legend: {
				//     orient: 'vertical',
				//     left: 'left'
				// },
				series: [
					{
						// name: 'Access From',
						type: 'pie',
						radius: '50%',
						data: [
							{ value: 1048, name: 'Search Engine' },
							{ value: 735, name: 'Direct' },
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)',
							},
						},
					},
				],
			};

			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,

				TrustFunction: this.forms.region1,
				ReleaseInstitute: this.forms.region2,
				MainSector: this.forms.region3,
				UseMode: this.forms.region4,

				RegisterStartDate: this.startDate,
				RegisterEndDate: this.endDate,

				PubStartDate: this.startDate2,
				PubEndDate: this.endDate2,
			};
			let _this = this;
			api.getPublicFundByYear4(params).then((res) => {
				//console.log(res.data,'res1111')
				option.series[0].data = res.data.data;
				_this.titleAnd1 = res.data.endDate;
				option && myChart.setOption(option);
			});
		},
		// 柱状图1
		echartsfn3() {
			var chartDom = document.getElementById('m1_echarts2');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				// dataZoom: [
				// 	{
				// 		start: 0,
				// 		end: 100,
				// 		height: 16,
				// 	},
				// ],
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: '{b}： {c} 只',
				},
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '16%',
					top: '3%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200, 150, 80, 70, 110, 130],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,

				TrustFunction: this.forms.region1,
				ReleaseInstitute: this.forms.region2,
				MainSector: this.forms.region3,
				UseMode: this.forms.region4,

				RegisterStartDate: this.startDate,
				RegisterEndDate: this.endDate,

				PubStartDate: this.startDate2,
				PubEndDate: this.endDate2,
			};
			let _this = this;
			api.getPublicFundByType4(params).then((res) => {
				option.series[0].data = res.data.data['yList'];
				option.xAxis.data = res.data.data['xList'];
				_this.titleAnd2 = res.data.endDate;
				option && myChart.setOption(option);
			});
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();

				$('.clearRegion4').addClass('active');
			}
		},
		// 点击日历切换函数
		changeDateFn2(res) {
			if (this.dateRaneg2.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate2 = startDate.substring(0, 10))
					: (this.startDate2 = '');
				endDate
					? (this.endDate2 = endDate.substring(0, 10))
					: (this.endDate2 = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();

				$('.clearRegion5').addClass('active');
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			// "pagesize":5,"curpage":1,"keyWords":"关键字","TrustFunction":"信托功能","RegisterStartDate":"登记开始日期","RegisterEndDate":"登记结束日期","ReleaseInstitute":"发行结构","PubStartDate":"公示开始日期","PubEndDate":"公示结束日期","MainSector":"主要投向行业","UseMode":"财产运用方式"
			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,

				TrustFunction: this.forms.region1,
				ReleaseInstitute: this.forms.region2,
				MainSector: this.forms.region3,
				UseMode: this.forms.region4,

				RegisterStartDate: this.startDate,
				RegisterEndDate: this.endDate,

				PubStartDate: this.startDate2,
				PubEndDate: this.endDate2,
			};
			this.loading = true;
			api.getGraphListData11(params).then((res) => {
				//console.log(res,'list');

				_this.dataList = res.data.rows;
				// _this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
		subData3: function(value) {
			return value.substring(0, 12);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.m1_echarts_box {
	width: 100%;
	overflow: hidden;
	margin-top: 85px;
	display: flex;
	justify-content: space-evenly;
}

.m1_echarts_alert {
	width: 313px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 200000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
.m1_top_box {
	width: 100%;
	overflow: hidden;
}
.m1_top_box h5 {
	width: 420px;
	height: 50px;
	line-height: 50px;
	float: left;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
}
.m1_top_box h5:first-child {
	margin-right: 40px;
}
.m1_top_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
.m1_echarts1 {
	width: 410px;
	height: 280px;
	float: left;
}
.m1_echarts2 {
	width: 400px;
	height: 280px;
	float: right;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 36px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}
.mailTable {
	font-size: 14px;
	color: #4b4b4b;
	width: 100%;
	font-family: Microsoft YaHei;
	background: rgb(245, 247, 245);
}
.mailTable tr {
	background: rgb(245, 247, 245);
}
.mailTable tr td.column {
	background-color: rgba(78, 172, 65, 0.15);
	// color: #dfecf7;
	font-size: 14px;
	font-weight: 700;
	width: 20%;
}
.mailTable tr td {
	border: 1px solid rgb(235, 238, 245);
	width: 80%;
	height: 35px;
	line-height: 35px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	padding: 0 10px;
	// color: #dfecf7;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}

// forms
.btn_search {
	width: 74px;
	height: 36px;
	background: #328046;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	display: inline-block;
	text-align: center;
	line-height: 36px;
	margin-left: 10px;
	cursor: pointer;
}
.btn_clear {
	width: 74px;
	height: 36px;
	background: #c7cbc6;
	border-radius: 1px;
	display: inline-block;
	text-align: center;
	line-height: 36px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	cursor: pointer;
}
.normalbtn {
	width: 42px;
	height: 40px;
	background: #328046;
	border-radius: 1px;
	display: inline-block;
	text-align: center;
	line-height: 40px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	cursor: pointer;
}
.normalbtn.active {
	background: #b9c5d9;
	color: #fff;
}
.article_l_title {
	width: 100%;
	height: 32px;
	line-height: 32px;
	overflow: hidden;
	border-bottom: 1px solid #e6e6e6;
	margin-top: 20px;
}
.article_l_title .img1 {
	width: 3px;
	display: inline-block;
	margin-right: 7px;
	float: left;
}
.article_l_title span {
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	float: left;
	display: inline-block;
	line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/lvcolumn/mode10.vue